import React from "react";
import Lodable from "react-loadable";
import { AppLoading } from "../loaders/loaders";
import appConstants from "../appConstants";
import DriverMapHeader from "../components/modules/Dispatch/RouteExecution/DriverMap/components/MapHeader";

const ShipmentsGrid = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/ShipmentsGrid"),
  loading: AppLoading,
});

const ShipmentsMap = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/ShipmentsMap"),
  loading: AppLoading,
});

const RoutesGrid = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/RoutesView/RoutesGrid"),
  loading: AppLoading,
});
const StopsGrid = Lodable({
  loader: () => import("../components/modules/IBPlanning/RoutesView/StopsGrid"),
  loading: AppLoading,
});
const RoutesMap = Lodable({
  loader: () => import("../components/modules/IBPlanning/RoutesView/RoutesMap"),
  loading: AppLoading,
});

const CustomerGrid = Lodable({
  loader: () => import("../components/modules/CustomerManagement/CustomerGrid"),
  loading: AppLoading,
})
const ShipperGrid = Lodable({
  loader: () => import("../components/modules/CustomerManagement/ShipperGrid"),
  loading: AppLoading,
})
const CustomerMap = Lodable({
  loader: () => import("../components/modules/CustomerManagement/CustomerMap"),
  loading: AppLoading,
})

const CustomerQuickFilter = Lodable({
  loader: () => import("../components/modules/CustomerManagement/QuickFilter"),
  loading: AppLoading,
})

const KPIPanel = Lodable({
  loader: () => import("../components/modules/IBPlanning/KPI/KPIPanel"),
  loading: AppLoading,
});
const SettingsPage = Lodable({
  loader: () => import("../components/modules/Settings/index"),
  loading: AppLoading,
});

const QuickFilter = Lodable({
  loader: () =>
    import("../components/modules/IBPlanning/ShipmentsView/QuickFilter"),
  loading: AppLoading,
});

const ReportsPage = Lodable({
  loader: () => import("../components/modules/Reports/index"),
  loading: AppLoading,
});

const DockComplianceKPIReport = Lodable({
  loader: () => import("../components/modules/Reports/DockCompliance/KPIPanel"),
  loading: AppLoading,
});

const DriverPerformance = Lodable({
  loader: () =>
    import("../components/modules/Reports/DriverPerformance/RealtimeReport"),
  loading: AppLoading,
});

const NextStopComplianceReportsKPI = Lodable({
  loader: () =>
    import("../components/modules/Reports/NextStopCompliance/KPIPanel"),
  loading: AppLoading,
});

const DispatchKPI = Lodable({
  loader: () => import("../components/modules/Dispatch/KPI/KPIPanel"),
  loading: AppLoading,
});

const DispatchedDriverGrid = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/Drivers/Grid"),
  loading: AppLoading,
});


const TrailersGrid = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/DriverManagement/TrailersGrid"),
  loading: AppLoading,
});
const DispatchDriversMap = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/DriverMap"),
  loading: AppLoading,
});
const DispatchPickupsGrid = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/RouteExecution/Pickups/Grid/index"),
  loading: AppLoading,
});
const DispatchQuickFilter = Lodable({
  loader: () =>
    import("../components/modules/Dispatch/DriverManagement/QuickFilter/index"),
  loading: AppLoading,
});

const ShipmentSelection = Lodable({
  loader: () =>
    import("../components/modules/ShipmentSelection"),
  loading: AppLoading,
});

export function getLayoutConfiguration(
  locationURL,
  configJSON
) {
  const { NAV_URLS } = appConstants;
  switch (locationURL.toLowerCase()) {
    case NAV_URLS.IBPLANNING_ROUTES:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "RoutesGrid",
                      id: appConstants.gridNames.RoutesGrid,
                      title: "Routes",
                      gridHeader: {
                        searchBox: true,
                        showHideColumn: true,
                        showTSP: true,
                        showMergeRoutes: true,
                        print: true,
                        showEdit: true,
                        showExportCSV: true,
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "RoutesMap",
                  customProp: "A",
                  title: "Routes Map",
                  id: appConstants.layout.RoutesMap,
                  isClosable: false,
                  gridHeader: {
                    toggleRouteAnimation: true,
                    mapTools: {
                      measureTool: true,
                      lasso: true,
                      delete: true,
                    },
                    print: {
                      showOnlyInMaximise: true,
                    },
                    showPopout: true,
                  },
                },
              ],

              height: 60,
            },
            {
              type: "stack",
              header: {
                popout: false,
              },
              content: [
                {
                  type: "react-component",
                  component: "StopsGrid",
                  id: appConstants.gridNames.StopsGrid,
                  customProp: "B",
                  title: "Stops",
                  gridHeader: {
                    searchBox: true,
                    showHideColumn: true,
                    showEdit: true,
                    showExportCSV: true,
                    showMergeStops: true,
                  },
                },
                {
                  type: "react-component",
                  component: "ShipmentsGrid",
                  location: locationURL,
                  title: "Shipments",
                  id: appConstants.gridNames.ShipmentsGrid,
                  gridHeader: {
                    searchBox: true,
                    showHideColumn: true,
                    showExportCSV: true,
                    showEdit: true,
                    geocode: true,
                    showShipmentComment: true,
                    revert: configJSON?.showDateRangeInShipmentSelection,
                    setAPT: configJSON?.showDateRangeInShipmentSelection
                  },
                },
              ],
              height: 30,
            },
            {
              type: "stack",
              content: [
                {
                  type: "react-component",
                  component: "KPIPanel",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                  minHeight: 50, //in pixel
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.IBPLANNING_SHIPMENTS:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "QuickFilter",
                      title: "Quick Filter",
                      id: appConstants.layout.QuickFilter,
                      header: {
                        popout: false,
                        show: false,
                      },
                      minWidth: 220, //in pixel
                    },
                  ],
                  width: 12.5,
                },
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "ShipmentsGrid",
                      location: locationURL,
                      title: "Shipments",
                      id: appConstants.gridNames.ShipmentsGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: true,
                        showExportCSV: true,
                        geocode: true,
                        showShipmentComment: true,
                        revert: configJSON?.showDateRangeInShipmentSelection,
                        setAPT: configJSON?.showDateRangeInShipmentSelection
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "ShipmentsMap",
                  //  customProp: 'E',
                  title: "Shipments Map",
                  id: appConstants.layout.ShipmentsMap,
                  isClosable: false,
                  gridHeader: {
                    mapTools: {
                      measureTool: true,
                      lasso: true,
                      delete: true,
                    },
                    showPopout: true,
                  },
                },
              ],
            },
            {
              type: "column",
              content: [
                {
                  type: "stack",
                  hideHeader: true,
                  content: [
                    {
                      type: "react-component",
                      component: "KPIPanel",
                      title: "KPI",
                      id: appConstants.layout.KPIPanel,
                      header: {
                        popout: false,
                        show: false,
                      },
                    },
                  ],
                  minHeight: 50, //in pixel
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.IBPLANNING_CUSTOMERS:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "CustomerQuickFilter",
                      title: "Quick Filter",
                      id: appConstants.layout.CustomerQuickFilter,
                      header: {
                        popout: false,
                        show: false,
                      },
                      minWidth: 220, //in pixel
                    },
                  ],
                  width: 12.5,
                },
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "CustomerGrid",
                      location: locationURL,
                      title: "Customers",
                      id: appConstants.gridNames.CustomerGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        showHideColumn: true,
                        showExportCSV: true,
                        geocode: true,
                      },
                    },
                    ...(configJSON?.showShippersInCustomerManagement
                      ? [
                          {
                            type: "react-component",
                            component: "ShipperGrid",
                            location: locationURL,
                            title: "Shippers",
                            id: appConstants.gridNames.ShipperGrid,
                            gridHeader: {
                              exportIcon: true,
                              searchBox: true,
                              showHideColumn: true,
                              showExportCSV: true,
                              geocode: true,
                            },
                          },
                        ]
                      : []),
                  ],
                },
                {
                  type: "react-component",
                  component: "CustomerMap",
                  //  customProp: 'E',
                  title: "Customers Map",
                  id: appConstants.layout.CustomerMap,
                  isClosable: false,
                  gridHeader: {
                    mapTools: {
                      measureTool: true,
                      lasso: true,
                      delete: true,
                    },
                    showPopout: true,
                  },
                },
              ],
            },
          ],
        },
      ];
    case NAV_URLS.SETTINGS:
      return [
        {
          type: "row",
          content: [
            {
              type: "react-component",
              component: "SettingsPage",
              title: "Settings",
              id: appConstants.layout.SettingsPage,
              header: {
                popout: false,
                show: false,
                maximise: false,
              },
            },
          ],
        },
      ];
    case NAV_URLS.SHIPMENT_SELECTION:
      return [
        {
          type: "row",
          content: [
            {
              type: "react-component",
              component: "ShipmentSelection",
              title: "Shipment Selection",
              id: "ShipmentSelection",
              header: {
                popout: false,
                show: false,
                maximise: false,
              },
            },
          ],
        },
      ];
    case NAV_URLS.REPORT_IBPSUMMARY:
    case NAV_URLS.REPORT_PUBLISH_STATUS:
    case NAV_URLS.REPORT_PRO_HISTORY:
    case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
    case NAV_URLS.REPORT_KPI_SUMMARY:
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
    case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
    case NAV_URLS.REPORT_USAGE_REPORT:
    case NAV_URLS.REPORT_MERGED_CUSTOMERS:
      return [
        {
          type: "row",
          content: [
            {
              type: "react-component",
              component: "ReportsPage",
              title: "Reports",
              id: appConstants.layout.Reports,
              header: {
                popout: false,
                show: false,
                maximise: false,
              },
            },
          ],
        },
      ];
    case NAV_URLS.REPORT_DOCK_COMPLIANCE:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "ReportsPage",
                      title: "Reports",
                      id: appConstants.layout.Reports,
                      header: {
                        popout: false,
                        show: false,
                        maximise: false,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "stack",
              hideHeader: true,
              content: [
                {
                  type: "react-component",
                  component: "KPIPanel",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 7,
              minHeight: 50, //in pixel
            },
          ],
        },
      ];
    case NAV_URLS.NEXT_STOP_COMPLIANCE:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "ReportsPage",
                      title: "Reports",
                      id: appConstants.layout.Reports,
                      header: {
                        popout: false,
                        show: false,
                        maximise: false,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "stack",
              hideHeader: true,
              content: [
                {
                  type: "react-component",
                  component: "NextStopComplianceReportsKPI",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 7,
              minHeight: 50, //in pixel
            },
          ],
        },
      ];
    case NAV_URLS.DISPATCH_ROUTEEXECUTION:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "column",
                  content: [
                    {
                      type: "react-component",
                      component: "DispatchPickupsGrid",
                      location: locationURL,
                      title: "Pickups",
                      id: appConstants.gridNames.PickupsGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: false,
                        showExportCSV: true,
                        geocode: false,
                        selectFilter: true,
                        mergePickupControl: true,
                        createPickupControl: true,
                        editPickupControl: true,
                        voidPickupControl: true,
                      },
                    },
                    {
                      type: "react-component",
                      component: "DispatchedDriverGrid",
                      location: locationURL,
                      title: "Drivers",
                      id: appConstants.gridNames.DispatchedDriverGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: false,
                        showExportCSV: true,
                        geocode: false,
                        equipmentDefects: true,
                        groupMsg: true,
                        cancelDispatch: true,
                        createDispatch: true,
                        endTrip: true,
                      },
                    },
                  ],
                },
                {
                  type: "react-component",
                  component: "DispatchDriversMap",
                  //  customProp: 'E',
                  title: "Dispatch Map",
                  id: appConstants.layout.DispatchDriversMap,
                  isClosable: false,
                  gridHeader: {
                    componentName: "DriverMapHeader",
                  },
                },
              ],
            },
            {
              type: "stack",
              content: [
                {
                  type: "react-component",
                  component: "DispatchKPI",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.DISPATCH_ASSET_MANAGEMENT:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "DispatchQuickFilter",
                      title: "Quick Filter",
                      id: appConstants.layout.DispatchQuickFilter,
                      header: {
                        popout: false,
                        show: false,
                      },
                      minWidth: 220, //in pixel
                    },
                  ],
                  width: 12.5,
                },
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "TrailersGrid",
                      location: locationURL,
                      title: "Trailers",
                      id: appConstants.gridNames.TrailersGrid,
                      gridHeader: {
                        exportIcon: true,
                        searchBox: true,
                        addIcon: false,
                        showHideColumn: true,
                        showEdit: false,
                        showExportCSV: true,
                        geocode: false,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "stack",
              hideHeader: true,
              content: [
                {
                  type: "react-component",
                  component: "DispatchKPI",
                  title: "KPI",
                  id: appConstants.layout.KPIPanel,
                  header: {
                    popout: false,
                    show: false,
                  },
                },
              ],
              height: 6,
            },
          ],
        },
      ];
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
      return [
        {
          type: "column",
          content: [
            {
              type: "row",
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "react-component",
                      component: "DriverPerformanceReport",
                      id: "dpReport",
                      title: "dpReport",
                      header: {
                        show: false,
                        maximise: false,
                      },
                    },
                  ],
                },
              ],

              height: 60,
            },
          ],
        },
      ];
  }
}
// In case we are using store then here we can pass it to the component
function wrapComponent(Component, theme) {
  class Wrapped extends React.Component {
    render() {
      return (
        //    <MuiThemeProvider theme={theme}>
        <Component {...this.props} />
        //    </MuiThemeProvider>
      );
    }
  }
  return Wrapped;
}
export function registerComponents(
  locationURL,
  layout,
  configJSON
) {
  const { NAV_URLS } = appConstants;
  switch (locationURL.toLowerCase()) {
    case NAV_URLS.IBPLANNING_ROUTES:
      layout.registerComponent("RoutesGrid", RoutesGrid);
      layout.registerComponent("ShipmentsGrid", ShipmentsGrid);
      layout.registerComponent("StopsGrid", StopsGrid);
      layout.registerComponent("RoutesMap", RoutesMap);
      layout.registerComponent("KPIPanel", KPIPanel);
      return layout;
    case NAV_URLS.IBPLANNING_SHIPMENTS:
      layout.registerComponent("ShipmentsMap", ShipmentsMap);
      layout.registerComponent("ShipmentsGrid", ShipmentsGrid);
      layout.registerComponent("QuickFilter", QuickFilter);
      layout.registerComponent("KPIPanel", KPIPanel);
      return layout;
    case NAV_URLS.IBPLANNING_CUSTOMERS:
      layout.registerComponent("CustomerGrid", CustomerGrid);
      configJSON?.showShippersInCustomerManagement &&
        layout.registerComponent("ShipperGrid", ShipperGrid);
      layout.registerComponent("CustomerMap", CustomerMap);
      layout.registerComponent("CustomerQuickFilter", CustomerQuickFilter);
      return layout;
    case NAV_URLS.DISPATCH_ROUTEEXECUTION:
      layout.registerComponent("DispatchKPI", DispatchKPI);
      layout.registerComponent("DispatchedDriverGrid", DispatchedDriverGrid);
      layout.registerComponent("DispatchPickupsGrid", DispatchPickupsGrid);
      layout.registerComponent("DispatchDriversMap", DispatchDriversMap);
      layout.registerComponent("DriverMapHeader", DriverMapHeader);
      return layout;
    case NAV_URLS.DISPATCH_ASSET_MANAGEMENT:
      layout.registerComponent("DispatchKPI", DispatchKPI);
      layout.registerComponent("DispatchQuickFilter", DispatchQuickFilter);
      layout.registerComponent("TrailersGrid", TrailersGrid);
      return layout;
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
      layout.registerComponent("DriverPerformanceReport", DriverPerformance);
      return layout;
    case NAV_URLS.SETTINGS:
      layout.registerComponent("SettingsPage", SettingsPage);
      return layout;
    case NAV_URLS.SHIPMENT_SELECTION:
      layout.registerComponent("ShipmentSelection", ShipmentSelection);
      return layout;
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
    case NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE:
    case NAV_URLS.REPORT_IBPSUMMARY:
    case NAV_URLS.REPORT_DOCK_COMPLIANCE:
    case NAV_URLS.REPORT_KPI_SUMMARY:
    case NAV_URLS.REPORT_PRO_HISTORY:
    case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
    case NAV_URLS.NEXT_STOP_COMPLIANCE:
    case NAV_URLS.REPORT_MERGED_CUSTOMERS:
    case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
    case NAV_URLS.REPORT_USAGE_REPORT:
      layout.registerComponent("ReportsPage", ReportsPage);
      layout.registerComponent("KPIPanel", DockComplianceKPIReport);
      layout.registerComponent(
        "NextStopComplianceReportsKPI",
        NextStopComplianceReportsKPI
      );
      return layout;
  }
}
